import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const uploaddocumentAWS = ({ formData }) =>
  axios.post(`${constants.apiHost}/files/attachdocumenttoAws`, formData, {
    headers: headersProvider(),
  });

export const attachDocuments = ({ fileData }) =>
  axios.post(`${constants.apiHost}/files/adddocument`, fileData, {
    headers: headersProvider(),
  });

export const getAllDocumentCategories = ({ tab, filter }) =>
  axios.post(
    `${constants.apiHost}/files/getalldocumentcategory`,
    { tab, filter },
    {
      headers: headersProvider(),
    },
  );

export const openDocument = ({ hostedLink }) =>
  axios.post(
    `${constants.apiHost}/files/viewdocument`,
    { hostedLink },
    {
      headers: headersProvider(),
    },
  );

export const removeDocument = ({ id }) =>
  axios.post(
    `${constants.apiHost}/files/deletedocument`,
    { id },
    {
      headers: headersProvider(),
    },
  );

export const updateDocument = ({ fileData, id }) =>
  axios.put(
    `${constants.apiHost}/files/updatedocument/${id}`,
    { fileData },
    {
      headers: headersProvider(),
    },
  );

export const getTagWords = ({ corporate }) => {
  return axios.post(
    `${constants.apiHost}/files/gettagwords`,
    {
      corporate,
    },
    {
      headers: headersProvider(),
    },
  );
};
export const getCategories = () =>
  axios.get(`${constants.apiHost}/files/getcategories`, {
    headers: headersProvider(),
  });

export const getUserList = () =>
  axios.get(`${constants.apiHost}/getuserslist`, {
    headers: headersProvider(),
  });
